import React from "react";

const PenaltyIcon = ({ cls }) => {
  return (
    <svg
      height="512"
      viewBox="0 0 96 96"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="Layer_4">
        <g>
          <path
            d="m62.564 27.39v-14.586c0-4.854-3.948-8.804-8.799-8.804h-31.098c-4.853 0-8.801 3.95-8.801 8.804v41.896c0 4.853 3.948 8.798 8.801 8.798h12.797v1.956c0 4.617 1.798 8.96 5.066 12.222.822.822 1.518 1.768 2.069 2.806l2.327 9.427c.302 1.226 1.406 2.091 2.672 2.091h25.64c1.298 0 2.419-.903 2.69-2.171l5.974-27.787c.634-3.166-.046-6.509-1.865-9.18zm-43.194 27.31v-41.896c0-1.822 1.478-3.3 3.297-3.3h31.098c1.817 0 3.295 1.478 3.295 3.3v39.628c0 1.741-1.368 4.429-3.187 4.429h-1.083v-9.072c0-4.794-3.872-8.691-8.634-8.691-4.792 0-8.691 3.897-8.691 8.691v10.207h-12.798c-1.819-.002-3.297-1.48-3.297-3.296zm51.645 31.796h-21.262l-1.887-7.648c-.048-.193-.118-.387-.21-.57-.838-1.672-1.927-3.187-3.238-4.493-2.225-2.225-3.451-5.181-3.451-8.331v-17.666c0-1.79 1.4-3.187 3.187-3.187 1.725 0 3.131 1.43 3.131 3.187v11.824c0 1.521 1.233 2.752 2.752 2.752h3.835c5.595 0 8.691-5.875 8.691-9.932v-15.309l12.929 18.845c.989 1.451 1.357 3.268 1.021 4.95z"
            fill="currentColor"
          />
          <path
            d="m43.698 34.544c.537.537 1.242.806 1.946.806s1.408-.269 1.946-.806c1.075-1.075 1.075-2.816 0-3.891l-5.485-5.485 5.485-5.485c1.075-1.075 1.075-2.816 0-3.891s-2.816-1.075-3.891 0l-5.485 5.485-5.482-5.485c-1.075-1.075-2.816-1.075-3.891 0s-1.075 2.816 0 3.891l5.485 5.485-5.485 5.485c-1.075 1.075-1.075 2.816 0 3.891.537.537 1.242.806 1.946.806s1.408-.269 1.946-.806l5.482-5.485z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};

export default PenaltyIcon;
